import SiteLayout from '../components/SiteLayout';
import StaticPage from '../components/StaticPage';
import { usePage } from '../hooks/useLocale';

export default function AboutPage() {
  const { t, content } = usePage('about');

  return (
    <SiteLayout t={t}>
      <StaticPage content={content} />
    </SiteLayout>
  );
}
